/* Violet Eyes menu categories (collection pages of Women and The Edit).
   Computers: the side menu. Phones (26 Oct): the "Categories +" line above the products opens a sheet with the same categories.
   A click on a category in the side menu adds it to, or takes it off, the picked categories; the
   products update in place (no Apply button). Picked categories show a black dot in the menu and an
   outlined box above the products (rendered by snippets/ve-picks-row.liquid, inside the product
   container). Several categories = their union: Shopify's own product-type filter on the Women
   collection (OR within one filter), so counts, sorting and "Show more" stay exact.
   Without this script, or with a modified click, a category link opens its normal collection page (the menu's own address, so search engines keep seeing the clean category pages). */
(() => {
  if (window.veMenuPicksReady) return;
  window.veMenuPicksReady = true;

  const wide = window.matchMedia('(min-width: 990px)');
  // Women's categories filter by product type, The Edit's by tag; the menu says which one this page uses.
  const param = () => nav().dataset.vePickParam || 'filter.p.product_type';
  const side = () => document.querySelector('.ve-side[data-ve-pick-base]');
  const sheet = () => document.getElementById('VeCatsSheet');
  // The element that knows the base collection, the filter parameter and the labels of this page: the side menu (computers) or the sheet (phones).
  const nav = () => side() || sheet();
  const container = () => document.getElementById('ProductGridContainer');
  const readRow = () => {
    const row = document.getElementById('VePicks');
    return row ? (row.dataset.vePicks || '').split('|').filter(Boolean) : null;
  };
  // Picked types the page shows now, or the ones just asked for while the products are still loading.
  let wanted = null;
  const picked = () => wanted || readRow() || [];

  // The base collection (Women, or all products for The Edit) with the picked values; every other filter and the sort stay as they are.
  const addressFor = (types) => {
    const target = new URL(nav().dataset.vePickBase, window.location.origin);
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (key === param() || key === 'page' || key === 'section_id') return;
      target.searchParams.append(key, value);
    });
    types.forEach((type) => target.searchParams.append(param(), type));
    return target;
  };

  // A row belongs to this page's group when its filter and its base collection are the page's (3 Nov: the phone sheet lists Women,
  // Men and The Edit; Women and Men both filter by product type, so the base collection tells them apart).
  const samePath = (a, b) => new URL(a, window.location.origin).pathname === new URL(b, window.location.origin).pathname;
  const ownGroup = (link) =>
    (!link.dataset.vePickParam || link.dataset.vePickParam === param()) &&
    // a page without a group of its own (Latest Drop): every sheet row opens its group's page
    (!link.dataset.vePickBase || (nav()?.dataset.vePickBase ? samePath(link.dataset.vePickBase, nav().dataset.vePickBase) : false));

  const toggled = (types, type) => (types.includes(type) ? types.filter((item) => item !== type) : [...types, type]);

  // The phone / hamburger menu marks the current page on the server, once, when the page loads. A category picked or taken off
  // afterwards (boxes, sheet, Clear all) changes the products in place, so its line must follow the picks here:
  // a category link is marked while it is picked, and "Shop all" (the base collection) only while nothing is picked.
  const syncDrawer = (types) => {
    const links = [...document.querySelectorAll('.ve-mnav a.ve-mnav__sublink')];
    const root = nav();
    if (!links.length || !root) return;
    // The sheet and the side menu list the same categories with their filter values; the drawer's links are matched by address.
    const pathOf = (link) => new URL(link.href, window.location.origin).pathname;
    const values = new Map();
    [...document.querySelectorAll('[data-ve-pick]')].forEach((item) => {
      if (item.dataset.vePickParam && item.dataset.vePickParam !== param()) return;
      values.set(pathOf(item), item.dataset.vePick);
    });
    const basePath = new URL(root.dataset.vePickBase, window.location.origin).pathname;
    links.forEach((link) => {
      const path = pathOf(link);
      let current = null;
      if (values.has(path)) current = types.includes(values.get(path));
      else if (path === basePath) current = types.length === 0;
      if (current === null) return;
      if (current) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  };

  // Dots, current page marks and addresses of the menu links follow the picked set.
  const syncMenu = (types) => {
    syncDrawer(types);
    const menu = side();
    const roots = [menu, sheet(), document.querySelector('.ve-sheet-cats')].filter(Boolean);
    if (!roots.length) return;
    roots.forEach((root) => root.querySelectorAll('[data-ve-pick]').forEach((link) => {
      // The sheet also lists the other group's categories: those are never picked on this page.
      const own = ownGroup(link);
      const on = own && types.includes(link.dataset.vePick);
      link.classList.toggle('is-selected', on);
      // A picked category's group is open (the page may have loaded with it in the address).
      const group = on ? link.closest('.ve-nav__sub[hidden]') : null;
      if (group) {
        group.hidden = false;
        root.querySelectorAll(`[aria-controls="${group.id}"]`).forEach((button) => button.setAttribute('aria-expanded', 'true'));
      }
      if (on) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    }));
    if (!menu) return;
    // "Shop all" (the base collection itself) is the current page only while nothing is picked.
    const basePath = new URL(menu.dataset.vePickBase, window.location.origin).pathname;
    menu.querySelectorAll('.ve-nav__sub a.ve-nav__link:not([data-ve-pick])').forEach((link) => {
      if (new URL(link.href, window.location.origin).pathname !== basePath) return;
      if (types.length === 0) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  };

  // Set by the end cross, the Categories sheet and the left menu (28 Oct, BNJMN): when a category comes off, the last one left in the path
  // comes first in the grid (begin() below reads it; refresh() clears it).
  let frontLast = false;
  // Positions of the path's names, bullets and cross, kept so the moved name can slide from where it was.
  const pathParts = () => {
    const row = document.getElementById('VePicks');
    if (!row) return [];
    let bullet = 0;
    return [...row.querySelectorAll('.ve-picks__box, .ve-picks__plus, [data-ve-pick-last]')].map((el) => ({
      el,
      key: el.dataset.vePickValue ? `b:${el.dataset.vePickValue}` : el.matches('.ve-picks__plus') ? `p:${bullet++}` : 'x',
    }));
  };
  const snapshotPath = () => new Map(pathParts().map(({ el, key }) => [key, el.getBoundingClientRect()]));
  const slidePath = (from) => {
    if (!from || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    pathParts().forEach(({ el, key }) => {
      const old = from.get(key);
      if (!old || !el.animate) return;
      const now = el.getBoundingClientRect();
      const dx = old.left - now.left;
      const dy = old.top - now.top;
      if (!dx && !dy) return;
      const inline = getComputedStyle(el).display === 'inline';
      if (inline) el.style.display = 'inline-block';
      const run = el.animate([{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'none' }], { duration: 500, easing: 'cubic-bezier(.4, 0, .2, 1)' });
      run.onfinish = run.oncancel = () => { if (inline) el.style.display = ''; };
    });
  };
  // A tapped name slides to the end of the path (29 Oct, BNJMN): nothing comes off, its products come first in the grid.
  let frontMoved = false;
  let slideFrom = null;
  const change = (types, { focus, scrollTop = true, last = false, moved = false } = {}) => {
    // 3 Nov (BNJMN): on phones, taking off the last picked category goes to Latest Drop (not the whole Women / all-products page)
    if (types.length === 0 && !wide.matches) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.href = `${root}collections/new-drop`;
      return;
    }
    if (!window.veCollection || !nav() || !container()) {
      window.location.href = addressFor(types).toString();
      return;
    }
    wanted = types;
    frontLast = last;
    frontMoved = moved;
    syncMenu(types);
    pendingFocus = focus || null;
    pendingScroll = scrollTop;
    window.veCollection.load(addressFor(types).toString());
  };
  let pendingFocus = null;
  let pendingScroll = false;

  const usable = (event) =>
    event.button === 0 && !(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) && wide.matches && window.veCollection && nav();

  // The same, for the sheet and the boxes on phones (the side menu is not shown there).
  const usableAnywhere = (event) =>
    event.button === 0 && !(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) && window.veCollection && nav();

  // Phones: open and close the sheet.
  let opener = null;
  let closing = false;
  // The sheet starts at the top of the first photos, so the "Categories +" line and the picked boxes stay whole above it.
  // Never higher than the header, and always at least about four rows tall.
  const positionSheet = () => {
    const dialog = sheet();
    if (!dialog || dialog.hidden) return;
    const first = document.querySelector('#ProductGridContainer .grid__item, #product-grid li, #product-grid .grid__item');
    const header = document.querySelector('ve-header');
    const floor = Math.max(0, header ? header.getBoundingClientRect().bottom : 0);
    const ceiling = Math.max(floor, window.innerHeight - 400);
    const wanted = first ? first.getBoundingClientRect().top : floor;
    // 3px higher than the first photos, so the photos' blurred edge and the rounding never peek out above the sheet
    dialog.style.setProperty('--ve-cats-top', `${Math.floor(Math.min(Math.max(wanted - 3, floor), ceiling))}px`);
  };
  window.addEventListener('resize', positionSheet);
  const openSheet = (button) => {
    const dialog = sheet();
    if (!dialog) return;
    opener = button || null;
    closing = false;
    dialog.classList.remove('is-closing');
    document.documentElement.classList.remove('ve-cats-closing');
    // a sheet closed by pulling it down starts clean the next time
    dialog.style.removeProperty('--ve-cats-drag');
    dialog.style.removeProperty('--ve-cats-veil');
    dialog.querySelector('.ve-cats-sheet__panel')?.style.removeProperty('transform');
    dialog.querySelector('.ve-cats-sheet__panel')?.style.removeProperty('transition');
    dialog.querySelector('.ve-cats-sheet__veil')?.style.removeProperty('opacity');
    // The sheet sits straight in the page body, so no parent of the header can hide it behind the page or stop the blur behind it.
    if (dialog.parentElement !== document.body) {
      document.querySelectorAll('body > #VeCatsSheet').forEach((old) => old.remove());
      document.body.appendChild(dialog);
    }
    dialog.hidden = false;
    positionSheet();
    document.documentElement.classList.add('ve-cats-lock');
    document.querySelectorAll('[data-ve-cats-open]').forEach((item) => item.setAttribute('aria-expanded', 'true'));
    (dialog.querySelector('.ve-cats-sheet__sect.is-open .ve-cats-sheet__row') || dialog.querySelector('.ve-cats-sheet__row, .ve-cats-sheet__group'))?.focus({ preventScroll: true });
  };
  const finishClose = (dialog) => {
    dialog.hidden = true;
    dialog.classList.remove('is-closing');
    document.documentElement.classList.remove('ve-cats-lock', 've-cats-closing', 've-drag-blur');
    document.documentElement.style.removeProperty('--ve-blur');
    document.querySelectorAll('[data-ve-cats-open]').forEach((item) => item.setAttribute('aria-expanded', 'false'));
    (document.querySelector('[data-ve-cats-open]') || opener)?.focus({ preventScroll: true });
    opener = null;
    closing = false;
  };
  // The sheet slides down and the page comes back into focus, then it is hidden.
  const closeSheet = () => {
    const dialog = sheet();
    if (!dialog || dialog.hidden || closing) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finishClose(dialog);
      return;
    }
    closing = true;
    dialog.classList.add('is-closing');
    document.documentElement.classList.add('ve-cats-closing');
    window.setTimeout(() => finishClose(dialog), 390);
  };
  // Another group's category (Women <-> The Edit) cannot be mixed with the picked ones: its own page opens with it picked.
  const startGroup = (row) => {
    const target = new URL(row.dataset.vePickBase, window.location.origin);
    target.searchParams.append(row.dataset.vePickParam, row.dataset.vePick);
    window.location.href = target.toString();
  };

  document.addEventListener('click', (event) => {
    const opening = event.target.closest('[data-ve-cats-open]');
    if (opening) {
      event.preventDefault();
      openSheet(opening);
      return;
    }
    // 3 Nov (BNJMN): a group line in the phone sheet opens its list and closes the one that was open (one group open at a time).
    const groupToggle = event.target.closest('[data-ve-cats-toggle]');
    if (groupToggle) {
      event.preventDefault();
      const sect = groupToggle.closest('.ve-cats-sheet__sect');
      if (!sect) return;
      const opening = !sect.classList.contains('is-open');
      // 3 Nov (BNJMN): the lists slide open and shut smoothly (like the Filter panel's groups) while the + turns into a –
      const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const ease = 'cubic-bezier(0.33, 0, 0.15, 1)';
      const slide = (item, open) => {
        const rows = item.querySelector('.ve-cats-sheet__rows');
        item.classList.toggle('is-open', open);
        item.querySelector('[data-ve-cats-toggle]')?.setAttribute('aria-expanded', String(open));
        if (!rows || still || typeof rows.animate !== 'function') return;
        rows.getAnimations().forEach((animation) => animation.cancel());
        if (open) {
          const height = rows.scrollHeight;
          rows.animate([{ height: '0px', opacity: 0 }, { height: `${height}px`, opacity: 1 }], { duration: 450, easing: ease });
        } else {
          item.classList.add('is-closing');
          const height = rows.offsetHeight;
          const animation = rows.animate([{ height: `${height}px`, opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 400, easing: ease });
          const done = () => item.classList.remove('is-closing');
          animation.onfinish = done;
          animation.oncancel = done;
          setTimeout(done, 650);
        }
      };
      sect.parentElement.querySelectorAll('.ve-cats-sheet__sect.is-open').forEach((item) => {
        if (item !== sect) slide(item, false);
      });
      slide(sect, opening);
      return;
    }
    if (event.target.closest('[data-ve-cats-close]')) {
      event.preventDefault();
      closeSheet();
      return;
    }
    // A category in the hamburger menu: the page used to reload (the menu vanished and the grid popped in from blank: the "jump",
    // BNJMN 29 Oct). Now it loads in place like the left menu: the menu fades away, the cards fade out and in. A category of another
    // group (Women <-> The Edit), Men, Latest Drop and the rest still open their own page.
    const drawerLink = event.target.closest('.ve-mnav a.ve-mnav__sublink');
    if (drawerLink && usable(event) && nav()) {
      const path = new URL(drawerLink.href, window.location.origin).pathname;
      const base = new URL(nav().dataset.vePickBase, window.location.origin).pathname;
      let value = null;
      document.querySelectorAll('[data-ve-pick]').forEach((item) => {
        if (item.dataset.vePickParam && item.dataset.vePickParam !== param()) return;
        if (new URL(item.href, window.location.origin).pathname === path) value = item.dataset.vePick;
      });
      if (value !== null || path === base) {
        event.preventDefault();
        document.querySelector('ve-header')?.close(false, true);
        window.veQuickLoad = true;
        change(value !== null ? [value] : [], { last: true });
        return;
      }
    }
    const sheetRow = event.target.closest('.ve-cats-sheet [data-ve-pick]');
    if (sheetRow) {
      if (!usableAnywhere(event)) return;
      event.preventDefault();
      if (!ownGroup(sheetRow)) startGroup(sheetRow);
      else change(toggled(picked(), sheetRow.dataset.vePick), { last: true });
      return;
    }
    const choice = event.target.closest('.ve-side [data-ve-pick], .ve-sheet-cats [data-ve-pick]');
    if (choice) {
      if (!usable(event)) return;
      event.preventDefault();
      change(toggled(picked(), choice.dataset.vePick), { last: true });
      return;
    }
    // "Shop all" in the left menu: the picks come off and the whole collection fades in, in place (29 Oct, BNJMN).
    const shopAll = event.target.closest('.ve-side a.ve-nav__link:not([data-ve-pick])');
    if (shopAll && usable(event) && picked().length && nav() &&
        new URL(shopAll.href, window.location.origin).pathname === new URL(nav().dataset.vePickBase, window.location.origin).pathname) {
      event.preventDefault();
      change([], { last: true });
      return;
    }
    const remove = event.target.closest('[data-ve-pick-remove]');
    if (remove) {
      if (!usableAnywhere(event)) return;
      event.preventDefault();
      change(picked().filter((type) => type !== remove.dataset.vePickRemove), { focus: { type: remove.dataset.vePickRemove } });
      return;
    }
    // With several categories picked, a tap on one of the names slides it to the end of the path (right before the cross):
    // the others stay picked and the tapped one's products come first in the grid (29 Oct, BNJMN; before, the others came off).
    const only = event.target.closest('#VePicks .ve-picks__box');
    if (only && picked().length > 1 && only.dataset.vePickValue) {
      if (!usableAnywhere(event)) return;
      event.preventDefault();
      const shown = [...document.querySelectorAll('#VePicks .ve-picks__box')].map((box) => box.dataset.vePickValue);
      const value = only.dataset.vePickValue;
      // Already the last one: nothing to move.
      if (shown[shown.length - 1] === value) return;
      slideFrom = snapshotPath();
      change([...shown.filter((type) => type !== value), value], { moved: true });
      return;
    }
    // The cross at the end of the path takes off the last category shown; the next tap takes off the one before.
    if (event.target.closest('[data-ve-pick-last]') || event.target.closest('[data-ve-pick-clear]')) {
      if (!usableAnywhere(event)) return;
      event.preventDefault();
      const shown = [...document.querySelectorAll('#VePicks .ve-picks__box')].map((box) => box.dataset.vePickValue);
      const last = shown[shown.length - 1];
      change(last ? picked().filter((type) => type !== last) : [], { focus: { first: true }, last: true });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeSheet();
    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches?.('#VePicks .ve-picks__box[role="button"]')) {
      event.preventDefault();
      event.target.click();
    }
  });

  // The header's Filter icon while the Categories sheet is open: the sheet closes at once (no slide, so it never lingers
  // behind the Filter panel) and the Filter panel opens as usual.
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-ve-pf-open]')) return;
    const dialog = sheet();
    if (!dialog || dialog.hidden) return;
    finishClose(dialog);
  }, true);

  // The same for the hamburger button: the sheet and the menu drawer share a layer and the sheet sits later in the page, so
  // the menu would open underneath it. The sheet closes at once and the menu opens as usual (the button's own handler runs next).
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-ve-menu-open]')) return;
    const dialog = sheet();
    if (!dialog || dialog.hidden) return;
    finishClose(dialog);
  }, true);

  // And the other way round: while the Filter panel is open, a tap where the "Categories +" line is (under the panel's
  // dimmed page) closes the Filter panel at once and opens the Categories sheet.
  document.addEventListener('click', (event) => {
    if (!document.documentElement.classList.contains('ve-pf-open')) return;
    const line = [...document.querySelectorAll('[data-ve-cats-open]')].find((item) => {
      const box = item.getBoundingClientRect();
      return box.width > 0 && event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
    });
    if (!line) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    document.getElementById('VePhoneFilter')?.close({ now: true });
    openSheet(line);
  }, true);

  // The grabber: a tap on the sheet's header closes it (data-ve-cats-close), and pulling the header down closes it too.
  // The sheet follows the finger; past about 90px (or a quick flick) it slides away, otherwise it springs back.
  let dragStartY = null;
  let dragStartTime = 0;
  let dragId = null;
  let dragDistance = 0;
  let dragging = false;
  let swallowClick = false;
  const dragParts = () => {
    const dialog = sheet();
    return dialog ? { dialog, panel: dialog.querySelector('.ve-cats-sheet__panel'), veil: dialog.querySelector('.ve-cats-sheet__veil') } : {};
  };
  document.addEventListener('pointerdown', (event) => {
    const head = event.target.closest('.ve-cats-sheet__head');
    if (!head || closing || (event.pointerType === 'mouse' && event.button !== 0)) return;
    dragStartY = event.clientY;
    dragStartTime = event.timeStamp;
    dragId = event.pointerId;
    dragDistance = 0;
    dragging = false;
  });
  document.addEventListener('pointermove', (event) => {
    if (dragStartY === null || event.pointerId !== dragId) return;
    const { panel, veil } = dragParts();
    if (!panel) return;
    dragDistance = Math.max(0, event.clientY - dragStartY);
    if (!dragging && dragDistance > 6) {
      dragging = true;
      panel.style.transition = 'none';
      try { event.target.closest('.ve-cats-sheet__head').setPointerCapture(event.pointerId); } catch (error) { /* not needed */ }
    }
    if (dragging) {
      panel.style.transform = `translateY(${dragDistance}px)`;
      if (veil) veil.style.opacity = String(1 - Math.min(dragDistance / Math.max(panel.offsetHeight, 1), 1) * 0.8);
      // the blur on the photos fades out in step with the pull (the page comes back into focus)
      const root = document.documentElement;
      root.classList.add('ve-drag-blur');
      root.style.setProperty('--ve-blur', `${(1.3 * (1 - Math.min((dragDistance / Math.max(panel.offsetHeight, 1)) * 2.5, 1))).toFixed(2)}px`);
    }
  });
  const endDrag = (event) => {
    if (dragStartY === null || event.pointerId !== dragId) return;
    const wasDragging = dragging;
    const distance = dragDistance;
    const speed = distance / Math.max(event.timeStamp - dragStartTime, 1);
    dragStartY = null;
    dragging = false;
    if (!wasDragging) return;
    // the click that follows a pull must not also count as a tap on the header
    swallowClick = true;
    window.setTimeout(() => { swallowClick = false; }, 80);
    const { dialog, panel, veil } = dragParts();
    document.documentElement.classList.remove('ve-drag-blur');
    if (!panel) return;
    if (event.type !== 'pointercancel' && (distance > 90 || (distance > 20 && speed > 0.6))) {
      dialog.style.setProperty('--ve-cats-drag', `${Math.round(distance)}px`);
      dialog.style.setProperty('--ve-cats-veil', veil ? veil.style.opacity || '1' : '1');
      panel.style.removeProperty('transition');
      panel.style.removeProperty('transform');
      veil?.style.removeProperty('opacity');
      closeSheet();
    } else {
      document.documentElement.style.removeProperty('--ve-blur');
      panel.style.transition = 'transform 0.2s ease';
      panel.style.transform = '';
      veil?.style.removeProperty('opacity');
      window.setTimeout(() => panel.style.removeProperty('transition'), 220);
    }
  };
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
  document.addEventListener('click', (event) => {
    if (!swallowClick) return;
    swallowClick = false;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  // Space also works on the menu links, as on a button.
  document.addEventListener('keydown', (event) => {
    if (event.key !== ' ' || event.target.closest('.ve-side [data-ve-pick], .ve-cats-sheet [data-ve-pick], .ve-sheet-cats [data-ve-pick]') === null) return;
    event.preventDefault();
    event.target.closest('[data-ve-pick]').click();
  });

  // The page's own row is the truth. One exception: on the Hebrew site Shopify does not list the tag filter
  // to the theme, so a page loaded with tags in its address (the filter itself works) has an empty row.
  // Then the row is built here from the address, with the names of the menu links.
  const reconcile = () => {
    const row = document.getElementById('VePicks');
    const root = nav();
    if (!row || !root || (row.dataset.vePicks || '').split('|').some(Boolean)) return;
    const inAddress = new URLSearchParams(window.location.search).getAll(param());
    // The sheet has the names too (and tells which group a category is in); the side menu has no such mark.
    const source = sheet() || root;
    const links = [...source.querySelectorAll('[data-ve-pick]')].filter(
      (link) => inAddress.includes(link.dataset.vePick) && (!link.dataset.vePickParam || link.dataset.vePickParam === param())
    );
    if (!links.length) return;
    const types = links.map((link) => link.dataset.vePick);
    row.dataset.vePicks = `${types.join('|')}|`;
    const remove = root.dataset.veRemoveLabel || '';
    const boxes = links.map((link) => {
      const box = document.createElement('span');
      box.className = 've-picks__box';
      box.textContent = ([...link.querySelectorAll('.ve-motion-sr')].map((node) => node.textContent).join('') || link.textContent).trim();
      box.dataset.vePickValue = link.dataset.vePick;
      return box;
    });
    const parts = [];
    boxes.forEach((box, index) => {
      if (index > 0) {
        const plus = document.createElement('span');
        plus.className = 've-picks__plus';
        plus.textContent = '•';
        parts.push(plus);
      }
      parts.push(box);
    });
    const clear = document.createElement('a');
    clear.className = 've-picks__clear';
    clear.href = addressFor(types.slice(0, -1)).toString();
    clear.dataset.vePickLast = '';
    clear.setAttribute('aria-label', `${remove} ${boxes[boxes.length - 1].textContent}`.trim());
    clear.textContent = '×';
    // the phone Filter icon at the end of the row stays (28 Oct)
    // (and the grid switch button, 31 Oct)
    const keepFilter = row.querySelector('.ve-picks__filter');
    const keepGrid = row.querySelector('.ve-grid-switch');
    row.replaceChildren(...parts, clear, ...(keepFilter ? [keepFilter] : []), ...(keepGrid ? [keepGrid] : []));
    row.hidden = false;
  };

  // The path in front of the picked categories: Home/ Women/ . Rebuilt from the row's data after every change, so it
  // survives the row being replaced. Women / Men with nothing picked: Home/ Women (current page, no link).
  const renderLead = (types) => {
    const row = document.getElementById('VePicks');
    if (!row) return;
    const scope = row.dataset.veScope === 'true';
    row.hidden = !types.length && !scope;
    row.removeAttribute('data-ve-type');
    row.querySelector(':scope > .ve-picks__lead')?.remove();
    [...row.childNodes].forEach((node) => {
      if (node.nodeType === 3 && !node.textContent.trim()) node.remove();
    });
    const lead = document.createElement('span');
    lead.className = 've-picks__lead';
    const crumb = (name, url) => {
      const node = document.createElement(url ? 'a' : 'span');
      node.className = url ? 've-picks__crumb ve-picks__crumb--up' : 've-picks__crumb';
      node.textContent = name;
      if (url) node.href = url;
      return node;
    };
    const sep = () => {
      const node = document.createElement('span');
      node.className = 've-picks__sep';
      node.textContent = '/ ';
      return node;
    };
    // Several picked: each name can be tapped to keep only it (keyboard too); one picked: plain text.
    row.querySelectorAll('.ve-picks__box').forEach((box) => {
      if (types.length > 1) {
        box.setAttribute('role', 'button');
        box.tabIndex = 0;
      } else {
        box.removeAttribute('role');
        box.removeAttribute('tabindex');
      }
    });
    lead.append(crumb(row.dataset.veHomeName || '', row.dataset.veHomeUrl || '/'), sep());
    if (types.length) lead.append(crumb(row.dataset.veParentName || '', row.dataset.veParentUrl || ''), sep());
    else if (scope) lead.append(crumb(row.dataset.veParentName || '', ''));
    row.prepend(lead);
  };

  // The path lists the categories in the order they were picked (28 Oct, BNJMN), not in the menu's order. The pick order is the
  // order in the address (each new pick is added at the end of it); the server draws the boxes in menu order, so they are put in order here
  // before anything is typed.
  const inPickOrder = () => {
    const row = document.getElementById('VePicks');
    if (!row) return;
    const current = (row.dataset.vePicks || '').split('|').filter(Boolean);
    if (current.length < 2) return;
    const order = wanted || new URLSearchParams(window.location.search).getAll(param());
    const rank = (value) => {
      const at = order.indexOf(value);
      return at < 0 ? Number.MAX_SAFE_INTEGER : at;
    };
    const byPick = (list, value) => list.map((item, at) => ({ item, at })).sort((x, y) => rank(value(x.item)) - rank(value(y.item)) || x.at - y.at).map((entry) => entry.item);
    const sorted = byPick(current, (value) => value);
    if (sorted.join('|') === current.join('|')) return;
    row.dataset.vePicks = `${sorted.join('|')}|`;
    const boxes = byPick([...row.querySelectorAll('.ve-picks__box')], (box) => box.dataset.vePickValue);
    const clear = row.querySelector('.ve-picks__clear');
    const anchor = clear || row.querySelector('.ve-picks__filter') || row.querySelector('.ve-grid-switch');
    row.querySelectorAll('.ve-picks__plus').forEach((plus) => plus.remove());
    boxes.forEach((box, at) => {
      if (at > 0) {
        const plus = document.createElement('span');
        plus.className = 've-picks__plus';
        plus.textContent = '•';
        row.insertBefore(plus, anchor);
      }
      row.insertBefore(box, anchor);
    });
    // the cross at the end takes off the last one shown: its address and label follow
    if (clear && boxes.length) {
      clear.href = addressFor(sorted.slice(0, -1)).toString();
      const old = clear.getAttribute('aria-label') || '';
      const was = boxes.find((box) => old.endsWith(box.textContent));
      const prefix = was ? old.slice(0, old.length - was.textContent.length) : `${nav()?.dataset.veRemoveLabel || ''} `;
      clear.setAttribute('aria-label', `${prefix}${boxes[boxes.length - 1].textContent}`.trim());
    }
  };

  // The category just added (28 Oct, BNJMN): its products come first in the grid, ahead of the other picked categories'.
  // Done in one go, out of sight (28 Oct night, BNJMN's OK): while the grid is still in its loading state, loadFilters
  // (assets/ve-collection.js) asks `begin()` for the first batch of that category alone, fetched together with the normal page,
  // and `apply()` puts that batch in front of the fetched (not yet shown) grid. The grid is then swapped in once with its usual
  // fade-in: no instant move first, no second move later. If that second request fails the page keeps Shopify's order.
  // "Show more" appends in Shopify's order and leaves out cards that are already on the page (assets/ve-collection.js).
  const productPath = (card) => {
    const link = card.querySelector('a[href*="/products/"]');
    return link ? new URL(link.getAttribute('href'), window.location.origin).pathname : '';
  };
  // Starts the extra request when the address adds a category to the picked ones; resolves to its product list, or null.
  const begin = (url, sectionId) => {
    try {
      if (previous === null || !nav()) return Promise.resolve(null);
      const target = new URL(url, window.location.href);
      const asked = target.searchParams.getAll(param());
      const added = asked.filter((type) => !previous.includes(type));
      // A category added: that one first. A category taken off with the end cross, in the Categories sheet or in the left menu (28 Oct, BNJMN):
      // the last one left in the path first (needs two or more left, with one the page already is that category).
      const removed = previous.filter((type) => !asked.includes(type));
      const first = added.length ? added[added.length - 1]
        : (frontLast && removed.length && asked.length > 1) || (frontMoved && asked.length > 1) ? asked[asked.length - 1] : null;
      if (!first) return Promise.resolve(null);
      // The same page for that category alone (other filters and the sort stay).
      const only = new URL(target);
      only.searchParams.delete(param());
      only.searchParams.delete('page');
      only.searchParams.append(param(), first);
      only.searchParams.set('section_id', sectionId);
      return fetch(only)
        .then((response) => (response.ok ? response.text() : Promise.reject(new Error(response.status))))
        .then((text) => {
          const list = new DOMParser().parseFromString(text, 'text/html').getElementById('product-grid');
          return list && list.tagName === 'UL' ? list : null;
        })
        .catch(() => null);
    } catch (error) {
      return Promise.resolve(null);
    }
  };
  // Puts the category's own batch first in the fetched grid (cards the grid already has are reused, the others come from the batch).
  const apply = (nextGrid, front) => {
    if (!front || !nextGrid) return;
    const list = nextGrid.querySelector('#product-grid');
    if (!list || list.tagName !== 'UL') return;
    const here = new Map([...list.children].map((card) => [productPath(card), card]));
    const first = [...front.children].map((card) => here.get(productPath(card)) || card);
    if (first.length) list.prepend(...first);
  };
  window.veMenuPicks = { begin, apply };

  // The products were replaced (a pick, a filter, back / forward).
  const refresh = () => {
    reconcile();
    inPickOrder();
    const types = readRow();
    if (types === null) return;
    if (typeToken) typeToken++;
    renderLead(types);
    typeAdded(types);
    slidePath(slideFrom);
    slideFrom = null;
    previous = types.slice();
    wanted = null;
    frontLast = false;
    frontMoved = false;
    syncMenu(types);
    const row = document.getElementById('VePicks');
    const status = document.getElementById('VePicksStatus');
    if (status && row) status.textContent = row.dataset.veStatus || '';
    if (pendingScroll) window.scrollTo({ top: 0, behavior: 'instant' });
    pendingScroll = false;
    // The row of boxes may have grown or shrunk: the sheet follows the first photos.
    requestAnimationFrame(positionSheet);
    if (pendingFocus) {
      const menu = side();
      const target = pendingFocus.first
        ? menu?.querySelector('[data-ve-pick]')
        : menu?.querySelector(`[data-ve-pick="${CSS.escape(pendingFocus.type)}"]`);
      target?.focus({ preventScroll: true });
      pendingFocus = null;
    }
  };

  // Typewriter (28 Oct, BNJMN): the path is typed out when a category page opens fresh, and every category added in place
  // types itself in. Removing a category or tapping the cross does not type anything.
  let typeToken = 0;
  let previous = null;
  const typeNodes = (row, nodes) => {
    if (!nodes.length || row.dataset.veTypewriter === 'false' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const texts = nodes.map((node) => node.textContent);
    if (!texts.join('').trim()) return;
    row.style.minHeight = `${row.getBoundingClientRect().height}px`;
    nodes.forEach((node) => {
      node.textContent = '';
    });
    const caret = document.createElement('span');
    caret.className = 've-picks__caret';
    caret.setAttribute('aria-hidden', 'true');
    const token = ++typeToken;
    let n = 0;
    let c = 0;
    const finish = () => {
      caret.remove();
      row.style.minHeight = '';
    };
    const step = () => {
      if (token !== typeToken || !row.isConnected) return finish();
      while (n < nodes.length && c >= texts[n].length) {
        n++;
        c = 0;
      }
      if (n >= nodes.length) {
        // BNJMN, 28 Oct: the caret blinks three more times (0.7s each) after the last letter before it goes
        setTimeout(finish, 500 + 3 * 700);
        return;
      }
      nodes[n].textContent = texts[n].slice(0, ++c);
      const host = nodes[n].parentNode === row ? nodes[n] : nodes[n].parentNode;
      host.after(caret);
      setTimeout(step, 55);
    };
    setTimeout(step, 150);
  };
  const textNodesOf = (elements) =>
    elements.flatMap((element) => {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      const found = [];
      while (walker.nextNode()) found.push(walker.currentNode);
      return found;
    });
  // Whole path on arrival.
  const typeRow = () => {
    const row = document.getElementById('VePicks');
    if (!row || row.hidden) return;
    typeNodes(row, textNodesOf([row]));
  };
  // Only the categories that were just added (and the bullet in front of them).
  const typeAdded = (types) => {
    const row = document.getElementById('VePicks');
    if (!row || row.hidden || previous === null) return;
    const added = types.filter((type) => !previous.includes(type));
    if (!added.length) return;
    const parts = [];
    added.forEach((type) => {
      const box = [...row.querySelectorAll('.ve-picks__box')].find((item) => item.dataset.vePickValue === type);
      if (!box) return;
      if (box.previousElementSibling?.classList.contains('ve-picks__plus')) parts.push(box.previousElementSibling);
      parts.push(box);
    });
    typeNodes(row, textNodesOf(parts));
  };

  const watch = () => {
    const grid = container();
    if (!grid || grid.dataset.veWatched) return;
    grid.dataset.veWatched = 'true';
    reconcile();
    refresh();
    typeRow();
    new MutationObserver(refresh).observe(grid, { childList: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  document.addEventListener('shopify:section:load', watch);
})();
